export const getCoordinatesFromUser = async () => {
  if (!window.navigator.geolocation) {
    console.error("Geolocation isn't supported");
    return { latitude: null, longitude: null };
  }

  console.log('Getting location');

  try {
    const position = await new Promise((resolve, reject) => {
      window.navigator.geolocation.getCurrentPosition(resolve, reject, {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      });
    });

    const { latitude, longitude } = position.coords;
    console.log('Location received:', { latitude, longitude });

    return { latitude, longitude };
  } catch (error) {
    console.error('Error getting location:', error);
    return { latitude: null, longitude: null, error };
  }
};
